<script setup>
import { provide, reactive } from 'vue';

const emit = defineEmits(['submit']);

const props = defineProps({
    placeholder: {
        type: String,
        default: 'Search',
    },
    context: {
        type: String,
    },
    default: {
        required: false,
    }
});

const state = reactive({
    open: false,
    query: props.default ?? '',
    placeholder: props.placeholder,
    context: props.context,
});

const search = {
    openView: () => {
        state.open = true;
    },
    closeView: () => {
        state.open = false;
    },
    submit: (query) => {
        state.query = query;
        emit('submit', query);
    },
    get state() {
        return state;
    },
};

provide('app-search', search);
</script>

<template>
    <div>
        <slot />
    </div>
</template>
